import { 
  collection, 
  addDoc, 
  updateDoc, 
  doc, 
  query, 
  getDocs,
  where,
  Timestamp,
  orderBy,
  getFirestore
} from 'firebase/firestore';
// import { db } from '../../config/firebase';
import type { Booking } from '../../types';

const COLLECTION_NAME = 'room-bookings';

export const bookingsService = {
  async createBooking(booking: Omit<Booking, 'id'>): Promise<string> {
    const bookingData = {
      ...booking,
      checkIn: Timestamp.fromDate(new Date(booking.checkIn.toString())),
      checkOut: Timestamp.fromDate(new Date(booking.checkOut.toString())),
      createdAt: Timestamp.fromDate(booking.createdAt),
      updatedAt: Timestamp.fromDate(booking.updatedAt)
    };
    
    const db = getFirestore();
    const docRef = await addDoc(collection(db, COLLECTION_NAME), bookingData);
    return docRef.id;
  },

  async updateBooking(bookingId: string, updates: Partial<Booking>): Promise<void> {
    const updateData = {
      ...updates,
      updatedAt: Timestamp.fromDate(new Date())
    };
    const db = getFirestore();
    await updateDoc(doc(db, COLLECTION_NAME, bookingId), updateData);
  },

  async getBookings(): Promise<Booking[]> {
    const db = getFirestore();
    const q = query(
      collection(db, COLLECTION_NAME),
      orderBy('createdAt', 'desc')
    );
    
    const querySnapshot = await getDocs(q);
    return querySnapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data(),
      checkIn: doc.data().checkIn.toDate(),
      checkOut: doc.data().checkOut.toDate(),
      createdAt: doc.data().createdAt.toDate(),
      updatedAt: doc.data().updatedAt.toDate()
    })) as Booking[];
  },

  async getBookingsByDateRange(startDate: Date, endDate: Date): Promise<Booking[]> {
    const db = getFirestore();
    const q = query(
      collection(db, COLLECTION_NAME),
      where('checkIn', '>=', Timestamp.fromDate(startDate)),
      where('checkIn', '<=', Timestamp.fromDate(endDate))
    );
    
    const querySnapshot = await getDocs(q);
    return querySnapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data(),
      checkIn: doc.data().checkIn.toDate(),
      checkOut: doc.data().checkOut.toDate(),
      createdAt: doc.data().createdAt.toDate(),
      updatedAt: doc.data().updatedAt.toDate()
    })) as Booking[];
  }
};
